/* ---------------- NEW: build city+points data from allBuses ---------------- */
const uniq = (arr) => [...new Set(arr.filter(Boolean))];

const normalizeText = (value = "") => value.trim().replace(/\s+/g, " ");
const normalizeKey = (value = "") => normalizeText(value).toLowerCase();

const extractTurnPoints = (bus, key) => {
  // key = "boardingPoints" or "droppingPoints"
  const out = [];
  try {
    const intervals = bus?.rotationSchedule?.intervals || [];
    intervals.forEach((it) => {
      const turns = it?.turns || [];
      turns.forEach((t) => {
        const pts = t?.[key] || [];
        pts.forEach((p) => out.push(normalizeText(p?.point || "")));
      });
    });
  } catch {}
  return out;
};

const buildLocationData = (buses) => {
  const citySet = new Map();
  const fromPointsByCity = new Map(); // city -> Set(points)
  const toPointsByCity = new Map();

  buses.forEach((b) => {
    const fromCityRaw = normalizeText(b?.from || "");
    const toCityRaw = normalizeText(b?.to || "");

    if (fromCityRaw) {
      const key = normalizeKey(fromCityRaw);
      if (!citySet.has(key)) citySet.set(key, fromCityRaw);
    }

    if (toCityRaw) {
      const key = normalizeKey(toCityRaw);
      if (!citySet.has(key)) citySet.set(key, toCityRaw);
    }

    // from points under FROM city
    const fromCity = fromCityRaw;
    const fromPts = [
      ...(Array.isArray(b?.boardingPoints)
        ? b.boardingPoints.map((p) => normalizeText(p?.point || ""))
        : []),
      ...extractTurnPoints(b, "boardingPoints"),
    ];
    if (fromCity) {
      const existingSet = fromPointsByCity.get(fromCity) || new Set();
      const normalizedSeen = new Set(
        Array.from(existingSet).map((point) => normalizeKey(point))
      );

      fromPts.forEach((p) => {
        const normalizedPoint = normalizeText(p);
        const key = normalizeKey(normalizedPoint);
        if (normalizedPoint && !normalizedSeen.has(key)) {
          existingSet.add(normalizedPoint);
          normalizedSeen.add(key);
        }
      });

      fromPointsByCity.set(fromCity, existingSet);
    }

    // to points under TO city
    const toCity = toCityRaw;
    const toPts = [
      ...(Array.isArray(b?.droppingPoints)
        ? b.droppingPoints.map((p) => normalizeText(p?.point || ""))
        : []),
      ...extractTurnPoints(b, "droppingPoints"),
    ];
    if (toCity) {
      const existingSet = toPointsByCity.get(toCity) || new Set();
      const normalizedSeen = new Set(
        Array.from(existingSet).map((point) => normalizeKey(point))
      );

      toPts.forEach((p) => {
        const normalizedPoint = normalizeText(p);
        const key = normalizeKey(normalizedPoint);
        if (normalizedPoint && !normalizedSeen.has(key)) {
          existingSet.add(normalizedPoint);
          normalizedSeen.add(key);
        }
      });

      toPointsByCity.set(toCity, existingSet);
    }
  });

  const cities = uniq(Array.from(citySet.values())).sort((a, b) =>
    a.localeCompare(b)
  );

  return { cities, fromPointsByCity, toPointsByCity };
};

export { uniq, extractTurnPoints, buildLocationData };
